import PageHeader from '../components/PageHeader';

type Clipping = {
    source: string
    tag: string
    author?: string
    url: string
    quote: string[]
}

const clippings: Clipping[] = [
    {
        source: 'The Beat',
        tag: 'Review — Sun City Poms',
        author: 'Chris Kennedy',
        url: 'https://www.thebeat.ie/o-kenayda-sun-city-poms-review-irish-alt-rock.php',
        quote: [
            'With Sun City Poms, O, Kenayda continue to prove that doing things differently can produce exciting results. Between the infectious guitar work, fuzz-heavy production and uncompromising DIY philosophy, the band have delivered another standout slice of Irish alternative rock that deserves to be heard.',
        ],
    },
    {
        source: 'Belfast Telegraph',
        tag: 'Review — Sun City Poms',
        author: 'Edwin McFee',
        url: 'https://www.belfasttelegraph.co.uk/sunday-life/entertainment/belfast-rockers-o-kenayda-announce-their-arrival-on-ni-music-scene-with-incendiary-debut-single/a/158373032.html',
        quote: [
            'O, Kenayda are bringing the heat this summer with their incendiary new single Sun City Poms.',
            'The track from the new band of seasoned tunesmiths is steeped in 90s slacker rock vibes and propelled by a powerhouse riff Jack White would swap his Just For Men stash for. It’s every bit the outsider anthem you need in your life right now.',
            'A catchy, reputation-making affair that fuses giddy melodies with gritty guitars, it’s a titanic track that is sure to bother more molars than a dodgy orthodontist.',
            'If you’re into the likes of Swami John Reis, Teenage Fanclub and the Golden Girls, you need to give this a listen.',
            'Sun City Poms is lifted from O, Kenayda’s debut album Orphans.',
        ],
    },
    {
        source: 'Hot Press',
        tag: 'Review — Animals',
        url: 'https://extra.ie/2026/06/29/hotpress/new-irish-songs-this-week-14',
        quote: [
            'Mirroring the consume-and-dump culture the songs respond to, almost every track clocks in under three minutes. Unusual? Yes. Does it work? Yes, and Animals is proof. The downtuned guitars and uplifting chorus have the spirit of 1990s alt-rock for a contemporary audience.',
        ],
    },
    {
        source: 'RTÉ',
        tag: 'Interview',
        url: 'https://www.rte.ie/entertainment/2026/0708/1581630-behind-the-music-o-kenayda/',
        quote: [
            'Behind the Music — the band talk through the three rules that shaped Orphans.',
        ],
    },
]

const Press = () => {
    return (
        <>
            <PageHeader title='Press' kicker='Reviews & interviews' />
            <section className='band band--flush-top'>
                <div className='container c_press_container'>
                    {clippings.map((clipping) => (
                        <article className='c_press_card' key={clipping.url}>
                            <span className='c_press_card__tag'>{clipping.tag}</span>
                            <h2 className='c_press_card__source'>{clipping.source}</h2>
                            <blockquote className='c_press_card__quote'>
                                {clipping.quote.map((paragraph) => (
                                    <p key={paragraph}>{paragraph}</p>
                                ))}
                            </blockquote>
                            <footer className='c_press_card__byline'>
                                <span className='c_press_card__author'>{clipping.author ? clipping.author : clipping.source}</span>
                                <a className='link-arrow' href={clipping.url} target='_blank' rel='noreferrer'>Read the full piece</a>
                            </footer>
                        </article>
                    ))}
                </div>
            </section>
        </>
    )
}
export default Press
